import React from 'react';
import { styles } from './PromoCard.css';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { useTrackingContext } from '../Tracking';

export type PromoCardProps = {
  isHidden?: boolean;
  image: React.ReactNode;
  href: string;
  isContained?: boolean;
  trackingLabel?: string;
  isDraft?: boolean;
};

export const PromoCard = ({ image, href, isContained, trackingLabel, isHidden }: PromoCardProps) => {
  const { tracker } = useTrackingContext();
  if (isHidden) return null;

  const handleClick = () => {
    tracker.trackClick({ label: trackingLabel, extraData: { moduleName: 'Promo Card' } });
  };

  return (
    <a
      className={classNames(styles.container, styles.containerVariants({ isContained }))}
      href={href}
      onClick={handleClick}
    >
      {image}
    </a>
  );
};

export type PromoCardCarouselProps = {
  cards: Array<PromoCardProps>;
};

export const PromoCardCarousel = ({ cards }: PromoCardCarouselProps) => {
  const isMobile = !useBreakpoint('md', 'up');
  const isDesktop = useBreakpoint('lg', 'up');
  const nonHiddenCardCount = cards.filter(cardProps => !cardProps.isHidden && !cardProps.isDraft).length;

  return (
    <div className={styles.carouselWrapper}>
      <Carousel
        slidesPerView="auto"
        showPagination={false}
        showProgressBar={isMobile || !isDesktop || nonHiddenCardCount > 3}
        showArrows={true}
        fullBleed={isMobile}
        spaceBetween={isDesktop && nonHiddenCardCount <= 3 ? 43 : 16}
        arrowPosition="bottom"
        slideArrowClassName={styles.slideArrow}
        rewind
      >
        {cards
          .filter(cardProps => !cardProps.isHidden && !cardProps.isDraft)
          .map((cardProps, i) => (
            <PromoCard {...cardProps} key={i} />
          ))}
      </Carousel>
    </div>
  );
};
